import { Channel } from 'src/app/models/channel';

export interface IReducer<T> {
    (state: T, action: IAction): T;
}

export interface IAction {
    type: string;
    payload?: any;
}

/* channel state */
export enum ChannelActionType {
    ChannelSelected = 'ChannelSelected'
}

export const channelReducer: IReducer<Channel> = (state: Channel, action: IAction) => {
    switch (action.type) {                
        case ChannelActionType.ChannelSelected:            
            return action.payload;

        default:
            // return previous state since no action defined
            return state;
    }       
}
/* end of channel state */

/* display mode state */
export enum DisplayModeActionType {
    //SubscriptionList = 'SubscriptionList',
    Subscription = 'Subscription',
    Favorite = 'Favorite',
    Today = 'Today'
}

export const displayModeReducer: IReducer<DisplayModeActionType> = (state: DisplayModeActionType, action: IAction) => {
    return DisplayModeActionType[action.type];
}
/* end of display mode state */

/* subscription display mode state */
export enum SubscriptionDisplayModeActionType {
    Grid = 'Grid',
    List = 'List'
}

export const subscriptionDisplayModeReducer: IReducer<SubscriptionDisplayModeActionType> = (state: SubscriptionDisplayModeActionType, action: IAction) => {
    return SubscriptionDisplayModeActionType[action.type];
}
/* end of subscription display mode state */